import { createEvent } from 'effector';

export const createObjectEv = createEvent();

export const resetCreatedObjectsEv = createEvent();

export const deleteCreatedObjectEv = createEvent()
